import React from 'react';
import { 
    AppBar, 
    Grid, 
    Hidden,
    IconButton,
    Toolbar, 
    Tooltip, 
    Typography 
} from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';


const styles = (theme: Theme) =>
createStyles({
  primaryBar: {
   padding: theme.spacing(1),
   backgroundColor: "rgba(255,255,255,1)",
   borderRadius: 3
  },
  menuButton: {
    marginLeft: -theme.spacing(1),
  },
  title: {
    marginLeft: theme.spacing(2),
  },
  
});

interface HeaderProps extends WithStyles<typeof styles> {
  onDrawerToggle: () => void;
  title: string;
}

const Header = (props: HeaderProps) => {
  const { classes, onDrawerToggle, title } = props;

  return (
    <>
      <AppBar color="primary" position="sticky" className={classes.primaryBar}>
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            <Hidden smUp>
              <Grid item>
                <IconButton
                  aria-label="open drawer"
                  onClick={onDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item xs>
              <Typography color="textPrimary" variant="h5" component="h1" className={classes.title}>
                {title}
              </Typography>
            </Grid>
            <Hidden xsUp>
                <Grid item>
                <Tooltip title="Alerts • No alerts">
                    <IconButton color="inherit">
                    <NotificationsIcon />
                    </IconButton>
                </Tooltip>
                </Grid>
            </Hidden>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
}

export default withStyles(styles)(Header);